import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";
export type GetCollectionEventByIdRequest = {
  collectionEventId: number;
  isCollectionIssue: boolean;
  collectionEventType: number;
};

export type GetCollectionEventByIdResponse = {
  collectionEvent: CollectionEventDetailsModel;
};

export const getCollectionEventById = async (request: GetCollectionEventByIdRequest) => {
  const response = await executeApiRequest(
    () =>
      axios.get<GetCollectionEventByIdResponse>(
        `/collectionevents/${request.collectionEventId}?isCollectionIssue=${request.isCollectionIssue}&collectionEventType=${request.collectionEventType}`
      ),
    false
  );

  return response?.data.collectionEvent;
};
